export interface BranchContentItem {
    title: string;
    subTitle: string;
    description: string;
}

export const BRANCH_CONTENT_DATA: BranchContentItem[] = [
    {
        title: 'Nghệ thuật Thiết kế Độc Quyền',
        subTitle: 'Định vị studio là nơi tạo ra các tác phẩm có ý nghĩa sâu sắc, không phải là hình xăm sao chép.',
        description: ' ',
    },
    {
        title: 'Theo Sát Hành Trình Cùng Khách Hàng',
        subTitle: 'Nâng cao trải nghiệm dịch vụ, tạo sự thoải mái, truyền cảm hứng và đẳng cấp cho khách hàng.',
        description: ' ',
    },
    {
        title: 'Vệ Sinh Lâm Sàng Tuyệt Đối',
        subTitle: 'Đảm bảo yếu tố an toàn sức khỏe hàng đầu, rất quan trọng với khách hàng.',
        description: ' ',
    },
    {
        title: 'Chuyên Môn Hóa Kỹ Thuật Xăm',
        subTitle: 'Đảm bảo chất lượng kỹ thuật vượt trội (Best-in-Class Expertise) cho mọi phong cách.',
        description: ' ',
    },
    {
        title: 'Cam Kết Chất Lượng Trọn Đời',
        subTitle: 'Xây dựng niềm tin tuyệt đối vào chất lượng vật liệu và kỹ thuật xăm của studio.',
        description: ' ',
    },
    {
        title: 'An Toàn Tuyệt Đối',
        subTitle: 'Da bạn – tấm toan nghệ thuật, cần được bảo vệ như vàng.',
        description: ' ',
      },
];